<template>

    <v-modal :title="$t('titles.cookie_preferences')" size="md">
        <template #body>
            <div class="essential-section">
                <v-modal-section :title="$t('labels.cookie_category_essential')" icon="fas fa-shield-check" :inactive="false" :padded="true">
                    <p>{{ $t('messages.cookie_category_essential_desc') }}</p>
                </v-modal-section>
            </div>
            <v-modal-section :title="$t('labels.cookie_category_functional')" icon="fas fa-sliders" :inactive="!params.functional" :padded="true" @input="params.functional = $event">
                <p>{{ $t('messages.cookie_category_functional_desc') }}</p>
            </v-modal-section>
            <v-modal-section :title="$t('labels.cookie_category_analytics')" icon="fas fa-chart-simple" :inactive="!params.analytics" :padded="true" @input="params.analytics = $event">
                <p>{{ $t('messages.cookie_category_analytics_desc') }}</p>
            </v-modal-section>
            <v-modal-section :title="$t('labels.cookie_category_marketing')" icon="fas fa-bullhorn" :inactive="!params.marketing" :padded="true" @input="params.marketing = $event">
                <p>{{ $t('messages.cookie_category_marketing_desc') }}</p>
            </v-modal-section>
        </template>
        <template #footer>
            <v-button size="sm" theme="white" @click.native="rejectAll">{{ $t('labels.reject_all') }}</v-button>
            <v-button size="sm" @click.native="save">{{ $t('labels.save_preferences') }}</v-button>
        </template>
    </v-modal>

</template>

<style scoped lang="scss">

    ::v-deep .modal-section-body p {
        text-align: left !important;
    }

    .essential-section {
        margin-bottom: 15px;
        ::v-deep .modal-section-header {
            cursor: default;
            pointer-events: none;
        }
    }

</style>

<script>

import Modal from '@cmp/Modal';
import ModalSection from '@cmp/ModalSection';
import ConsentUtil from '@utils/ConsentUtil';

export default {

    components: {
        'v-modal': Modal,
        'v-modal-section': ModalSection,
    },

    data() {
        const consent = ConsentUtil.getConsent();
        return {
            params: {
                functional: consent ? !!(consent.categories.functional) : true,
                analytics: consent ? !!(consent.categories.analytics) : false,
                marketing: consent ? !!(consent.categories.marketing) : false,
            },
        };
    },

    methods: {

        save() {
            ConsentUtil.setConsent({
                essential: true,
                functional: this.params.functional,
                analytics: this.params.analytics,
                marketing: this.params.marketing,
            });
            this.$store.commit('setModal', null);
        },

        rejectAll() {
            ConsentUtil.rejectAll();
            this.$store.commit('setModal', null);
        },

    },

}

</script>
